import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 10l6 6l6 -6h-12","key":"svg-0"}]]

const IconCaretDown = createReactComponent('outline', 'caret-down', 'CaretDown', __iconNode);

export default IconCaretDown;